import React, { useEffect, useState } from 'react';
import { TChainName, TParsedContractCallParams } from '../types';
import { Contract } from 'ethers';
import { getAggregatorContract } from '../utils';

export function useEncodeCalls(
    chainName: TChainName,
    calls: TParsedContractCallParams[]
): { encodedCalls: string, callsError: string, encodeCalls: () => void } {

    console.log("calls:", calls);

    const [encodedCalls, setEncodedCalls] = useState<string>('');
    const [callsError, setCallsError] = useState<string>('');

    const encodeCalls = () => {
        (async () => {

            const aggregator: Contract = getAggregatorContract(chainName);

            const encoded: string = await aggregator.encodeCalls(calls);

            if (encoded) {
                setEncodedCalls(encoded);
                setCallsError('');
            }

        })().catch((e: { message: string }) => {
            setCallsError(e.message);
            console.error("useEncodeCalls", e)
        })
    }

    useEffect(() => {

        encodeCalls();

    }, [calls]);

    return { encodedCalls, callsError, encodeCalls }

}